export default __webpack_public_path__ + "static/media/icon_course_program_q.6f5d3d16.svg";